import { useState } from "react";
import { downloadPrivateObject } from "@retro-ia/shared/upload";

export type ArchivoActividadRef = {
  llave: string;
  nombre: string;
  url?: string;
};

export function tieneArchivoAdjunto(
  archivo: ArchivoActividadRef | null | undefined,
): archivo is ArchivoActividadRef {
  return !!(archivo?.llave || archivo?.url);
}

/** Descarga vía llave (presign) o URL directa. */
export async function descargarArchivoActividad(
  archivo: ArchivoActividadRef,
): Promise<void> {
  if (archivo.llave) {
    const { url } = await downloadPrivateObject({ key: archivo.llave });
    window.open(url, "_blank");
  } else if (archivo.url) {
    window.open(archivo.url, "_blank");
  }
}

export function DescargaArchivoActividadLink({
  archivo,
  className,
  labelPrefix,
}: {
  archivo: ArchivoActividadRef;
  className?: string;
  /** Ej. "PDF" o "Word" para el texto del enlace. */
  labelPrefix?: string;
}) {
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    setLoading(true);
    try {
      await descargarArchivoActividad(archivo);
    } finally {
      setLoading(false);
    }
  };
  const texto =
    labelPrefix != null
      ? `${labelPrefix}: ${archivo.nombre}`
      : `Descargar archivo: ${archivo.nombre}`;
  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className={
        className ??
        "text-[var(--secondary)] underline text-sm mb-2 text-left disabled:opacity-50"
      }
    >
      {loading ? "..." : texto}
    </button>
  );
}
